// -- MESSAGES
const _MESSAGES = {
  required: "* Campo obrigatório",
  pwd_match: "* As passwords não coincidem",
  invalidEmail: "* E-mail inválido",
  invalidPassword:
    "* A password deve conter no minimo 8 carateres (maiúscula, minúscula, alfanumérico, simbolo)",
  invalidNumber: "* O valor inserido deve ser numérico",
  invalidFloat: "* O valor inserido deve ser decimal"
}

const RULES = {
  computed: {
    RULES() {
      return {
        required: v => !!v || _MESSAGES.required,
        match_pwd: v => v == this.MyObject.password || _MESSAGES.pwd_match,
        email: v =>
          /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v
          ) || _MESSAGES.invalidEmail,
        isNumber: v => !!Number.isInteger(Number(v)) || _MESSAGES.invalidNumber,
        isFloat: v => !!!Number.isNaN(parseFloat(v)) || _MESSAGES.invalidFloat
      }
    }
  }
}

export default RULES
